import React, { useState, useMemo } from 'react';
import { formatePhoneNumber } from '../../../utils/helpers';
import { useSelector } from 'react-redux';

// Helper to normalize emojis (remove skin tones)
const normalizeEmoji = (emoji) => emoji.replace(/[\u{1F3FB}-\u{1F3FF}]/gu, '');

const ReactionModal = ({ message = [], onClose }) => {
  const { session } = useSelector((state) => state.auth);
  const [selectedTab, setSelectedTab] = useState('All');

  // Group reactions by base emoji
  const groupedReactions = useMemo(() => {
    const groups = {};
    for (const reaction of message) {
      const baseEmoji = normalizeEmoji(reaction.emoji);
      if (!groups[baseEmoji]) groups[baseEmoji] = [];
      groups[baseEmoji].push(reaction);
    }
    return groups;
  }, [message]);

  // Filtered reactions based on selected tab
  const filteredReactions = useMemo(() => {
    if (selectedTab === 'All') return message;
    return groupedReactions[selectedTab] || [];
  }, [selectedTab, message, groupedReactions]);

  const generateReactorName = (contact) => {
    const {name, push_name} = contact;

    const startsWithNumber = (value) => /^\d/.test(value);
    
    if (!startsWithNumber(name)) return name;
    else if (session?.client_id === contact.wa_id) return 'You';

    return `${push_name ? push_name : ''}`;
  }

  return (
    <div className="reaction-modal-backdrop" onClick={onClose}>
      <div className="reaction-modal" onClick={(e) => e.stopPropagation()}>
        <div className='reaction-header'>
          <div className='reaction-tabs'>
            <button 
              className={selectedTab === 'All' ? 'active' : ''} 
              onClick={() => setSelectedTab('All')}
            >
              All {message.length}
            </button>
            {Object.keys(groupedReactions).map((emoji, index) => (
              <button 
                key={index} 
                className={selectedTab === emoji ? 'active' : ''} 
                onClick={() => setSelectedTab(emoji)}
              >
                {emoji} {groupedReactions[emoji].length}
              </button>
            ))}
          </div>
        </div>

        <div className='reaction-body'>
          {filteredReactions.length === 0 ? (
            <p>No reactions found.</p>
          ) : (
            filteredReactions.map((reaction, index) => (
              <div key={index} className="reaction-item">
                <div className='reaction-info'>
                  {reaction.reactor && <p>{generateReactorName(reaction.reactor)}</p>}
                  <p>{formatePhoneNumber(reaction.reactor_jid)}</p>
                </div>
                <span className="emoji">{reaction.emoji}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ReactionModal;
